import React, { Component } from 'react'
import axios from 'axios'
import { Box, Button, TextField, Heading, Toast,Dropdown } from 'monday-ui-react-core';
import DOMPurify from 'dompurify';
import env from "react-dotenv";
let baseUrl = process.env.REACT_APP_SERVER_URL;

export default class AllocateForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            assetName: this.props.assetName,
            description: this.props.description,
            status: this.props.status,
            requestId: '',
            managerId: '',
            assetId: this.props.assetId,
            allocateComment: '',
            isLoading: false,
            successOrErrorMessageNotice: '',
            isToast: false,
            isToastOpen: false,
            messageSuccessOrFailure: '',
            requestsData:this.props.requests,
			workOrderTaskList: [], // New state to store the list of work order tasks
			assignTo: '',
		  task: {
			instructions: '',
			resources: '',
			estimatedTime: '',
		  },
		  
		  beforeAttachmentFile:'',
		  finalTaskList: []
        }
    }

    async componentDidMount() {
        // Retrieve a value from local storage
        if (localStorage.getItem("managerId")) {
            this.setState({
                managerId: localStorage.getItem("managerId")
            })
        }
    }

	 // Function to handle changes in work order task details
  
  
    // Function to remove the last task from the list

    onChangeRequestId = (eventRequestId) => {
        this.setState({
            requestId: eventRequestId
        })
    }

    handleRequestId = (e)=>{
        this.setState({
            requestId: e.value
        })
    }

    onChangeManagerId = (eventManagerId) => {
        this.setState({
            managerId: eventManagerId
        })
    }

    onChangeAllocateComments = (eventComments) => {
        this.setState({
            allocateComment: eventComments
        })
    }
	
	onChangeAssign = (assignTo) => {
        this.setState({
            assignTo: assignTo
        })
    }

    onClickAllocate = async () => {
        this.setState({
            isLoading: true
        })
        let { assetName, description, status, requestId, managerId, assetId, allocateComment,finalTaskList , assignTo} = this.state;
        allocateComment = DOMPurify.sanitize(allocateComment);
        if (assetName && description && status && managerId && assetId && allocateComment && requestId) {
            const successMessasge = "Asset allocated successfully";
            const errorMessage = "Failed to Allocate";
            const managerError = "Invalid manager Id";
            let formData = {
                "managerId": managerId,
                "requestId": requestId,
                "comment": allocateComment,
                "type": "Physical",
                "requestType": status === "Active" ? "request" : "return",
                "assetId": assetId,
            }
            await axios.post(`${baseUrl}/asset-request`, formData)
                .then((res) => {
                    this.setState({
                        isLoading: false,
                        isToast: true,
                        messageSuccessOrFailure: successMessasge
                    })
                    window.location.replace(res.data);
                })
                .catch((err) => {
                    if (err.response.status === 401 || err.response.status === 404) {
                        this.setState({
                            isLoading: false,
                            isToast: true,
                            messageSuccessOrFailure: managerError
                        })
                            this.setState({
                                isManagerIdPresent: false
                            })
                    }
                    else {
                        this.setState({
                            isLoading: false,
                            isToast: true,
                            messageSuccessOrFailure: errorMessage
                        })
                    }

                })
        }
        else {
            this.setState({
                isLoading: true
            })
            const errorMessage = "Please fill all the fields";
            this.setState({
                isLoading: false,
                isToast: true,
                messageSuccessOrFailure: errorMessage,
            })
        }
    }


    render() {
        const { assetName, description, status, requestId, managerId, allocateComment, messageSuccessOrFailure, isToast,assignTo } = this.state;
        return (
            <>
                <div style={{width:'300px',alignItems:'center'}}>
                    {
                        isToast ?
                            <div>
                                {
                                    messageSuccessOrFailure === "Asset allocated successfully" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.POSITIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> :
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div>
                                }
                                {
                                    messageSuccessOrFailure === "Please fill all the fields" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> : null
                                }
                                {
                                    messageSuccessOrFailure === "Invalid manager Id" ?
                                        <div>
                                            <Toast open onClose={this.onCloseCallback} closeable={false} type={Toast.types.NEGATIVE} className="monday-storybook-toast_wrapper">{messageSuccessOrFailure}</Toast>
                                        </div> : null
                                }
                            </div> : null
                    }
                    <br />
                    <br />
                    <Box className='box' border={Box.borders.DEFAULT} paddingX={Box.paddingXs.MEDIUM} paddingY={Box.paddingYs.MEDIUM} rounded={Box.roundeds.MEDIUM}>
                        <Heading value='Allocation Form' type={Heading.types.h2} style={{ textAlign: "center" }} />
                        <TextField
                            title="Name"
                            value={assetName}
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                            readonly
                        />
                        <br />
                        <TextField
                            title="Description"
                            value={description}
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <TextField
                            title="Status"
                            value={status}
                            wrapperClassName="monday-storybook-text-field_size"
                            requiredAsterisk={true}
                            readonly
                        />
                        <br />
                        <div style={{padding:'8px',paddingLeft:"0px"}}>
                <label>Request Id<span className='asterisk'>*</span></label>
            </div>
                        <Dropdown placeholder="Choose request Id" options={this.state.requestsData} className="dropdown-stories-styles_big-spacing" onChange={(e)=>this.handleRequestId(e)} />

                        <br />
                        <TextField
                            onChange={(eventManagerId) => this.onChangeManagerId(eventManagerId)}
                            type={TextField.types.PASSWORD}
                            value={managerId}
                            title="Asset Manager ID"
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        <br />
                        <TextField
                            onChange={(eventComments) => this.onChangeAllocateComments(eventComments)}
                            value={allocateComment}
                            title="Comments"
                            requiredAsterisk={true}
                            wrapperClassName="monday-storybook-text-field_size"
                        />
                        
						<br />
                        <br />
		<br/><br/><br/>
                        <Button loading={this.state.isLoading} style={{ float: 'right' }} onClick={this.onClickAllocate}>Allocate</Button>

                    </Box>
                </div>
            </>
        )
    }
}
